import { Button, TextField, Typography } from '@musinsa/mds';
import { twMerge } from 'tailwind-merge';

interface FormImageSelectFieldProps {
  titleContent?: string;
  helpText?: string;
  errorText?: string;
  id: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  error?: boolean;
  className?: string;
  /**
   * input 요소의 accept 속성. 기본값은 "image/jpeg, image/png, image/gif".
   * null 전달 시 속성 자체를 제거해 파일시스템 전체 선택을 허용한다.
   */
  accept?: string | null;
}

const DEFAULT_ACCEPT = 'image/jpeg, image/png, image/gif';

export const FormImageSelectField = ({
  titleContent,
  helpText,
  errorText,
  id,
  value,
  onChange,
  error,
  className,
  accept = DEFAULT_ACCEPT,
}: FormImageSelectFieldProps) => {
  const handleFileInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange?.(e);
    // 동일 파일을 다시 고를 때도 change 이벤트가 나가도록 네이티브 값 초기화
    e.target.value = '';
  };

  return (
    <div className={twMerge('flex flex-col gap-2 py-2', className)}>
      {titleContent && <Typography variant="body14pxMed">{titleContent}</Typography>}

      <div className="flex items-center gap-[4px]">
        <TextField
          variant="outlined"
          placeholder="이미지를 선택해주세요"
          value={value ?? ''}
          error={error}
          readOnly
          className="flex-1 min-w-0"
        />

        <Button
          variant="secondary"
          size={36}
          type="button"
          className="cursor-pointer shrink-0"
          asChild
        >
          <label htmlFor={id} className="cursor-pointer">
            <Typography size="13" weight="medium">
              선택
            </Typography>
          </label>
        </Button>

        <input
          id={id}
          type="file"
          accept={accept ?? undefined}
          onChange={handleFileInputChange}
          className="hidden"
        />
      </div>

      {error && errorText && (
        <Typography variant="textEtc11pxReg" colorScheme="red" wordBreak="breakWords">
          {errorText}
        </Typography>
      )}

      {helpText && (
        <Typography variant="textEtc11pxReg" colorScheme="gray-500" wordBreak="breakWords">
          {helpText}
        </Typography>
      )}
    </div>
  );
};
